// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__WN9v0","signatureBlock":"Footer_signatureBlock__1ZZUA","signature":"Footer_signature__1_-eC"};